const en = {
  //All files static data
  //siderbar file start
  Welcome: "Welcome",
  "Loading businesses...": "Loading businesses...",
  "No businesses available": "No businesses available",
  Dashboard: "Dashboard",
  Menu: "Menu",
  Orders: "Orders",
  Offers: "Offers",
  "Genie Tag": "Genie Tag",
  "Business Report": "Business Report",
  Photos: "Photos",
  "Social Networks": "Social Networks",
  "Shop Now": "Shop Now",
  Profile: "Profile",
  Logout: "Logout",
  "Customer Orders": "Customer Orders",
  "Business Reports": "Business Reports",
  "Select Business": "Select Business",
  //sidebar file end
  //Login File Start
  loginTitle: "Login",
  emailPlaceholder: "Email",
  passwordPlaceholder: "Password",
  loginButton: "Login",
  forgotPassword: "Forgot Password?",
  or: "Or",
  resetPasswordTitle: "Reset Password",
  enterEmailLabel: "Enter your email",
  cancel: "Cancel",
  sendResetLink: "Send Reset Link",
  resetSuccess: "Reset link sent successfully. Check your email.",
  resetError: "Error sending reset email. Try again.",
  enterEmailPrompt: "Please enter your email.",
  incorrectPassword: "Incorrect password. Please try again.",
  noUserFound: "No user found with this email. Please register.",
  loginFailed: "Login failed. Please try again.",
  "Reset Password": "Reset Password",
  //Login file end
  //Dashboard file start
  Reviews: "Reviews",
  Ratings: "Ratings",
  Scans: "Scans",
  Clicks: "Clicks",
  "Active Offers": "Active Offers",
  "No Offers available": "No Offers available",
  "Scans Overview": "Scans Overview	",
  "Filter by": "Filter by",
  Reset: "Reset",
  Apply: "Apply",
  "No Scans Available": "No Scans Available",
  "Clicks Overview": "Clicks Overview",
  "No Clicks Available": "No Clicks Available",
  "Latest Reviews": "Latest Reviews",
  "View All Reviews": "View All Reviews",
  "Show Less": "Show Less",
  "Coupon code copied": "Coupon code copied",
  //Dashboard file end
  //MenuContent file start
  "Menu Management": "Menu Management",
  "Add Category": "Add Category",
  "No Categories Displaying":
    "There are no categories yet. Click 'Add Category' to create one and get started!",
  "Menu item": "Menu item",
  "No Menu Items Displaying":
    "There are no Menu Items yet. Click 'ADD Menu Item' to create one and get started!",
  "No items available": "No items available",
  "Add New Menu Item": "Add New Menu Item",
  "Edit Menu Item": "Edit Menu Item",
  Yes: "Yes",
  No: "No",
  "Are you sure you want to delete this item?":
    "Are you sure you want to delete this item?",
  "Add Menu Item": "Add Menu Item",
  "Add Item": "Add Item",
  Price: "Price",
  "Item Name": "Item Name",
  //MenuContent file end
  //CategoryCreation file start
  "Select Categories": "Select Categories",
  "Search Category": "Search Category",
  Back: "Back",
  "Are you sure you want to delete": "Are you sure you want to delete",
  Delete: "Delete",
  Cancel: "Cancel",
  //CategoryCreation file end
  //OrdersContent file start
  "Your Orders": "Your Orders",
  "Order ID	": "Order ID	",
  Date: "Date",
  "Product Name": "Product Name",
  Amount: "Amount",
  "View Genie Tags": "View Genie Tags",
  "Your Genie Tags": "Your Genie Tags",
  Business: "Business",
  Status: "Status",
  "No Genie Tags available.": "No Genie Tags available.",
  "No orders found.": "No orders found.",
  "Transaction ID": "Transaction ID",
  //OrdersContent file end
  //Customer Orders file Start
  "Create Order": "Create Order",
  "Customer Details": "Customer Details",
  "Business Name": "Business Name",
  "Transaction Details": "Transaction Details",
  "Assign Genie Tags": "Assign Genie Tags",
  "Activate": "Activate",
  "Activate all inactive tags": "Activate all inactive tags",
  "All Genie Tags are active.": "All Genie Tags are active.",
  "Inactive Genie Tags can be activated below.": "Inactive Genie Tags can be activated below.",
  "Active": "Active",
  "Inactive": "Inactive",
  "Genie Tag activated.": "Genie Tag activated.",
  "Genie Tags activated.": "Genie Tags activated.",
  "Failed to activate Genie Tags.": "Failed to activate Genie Tags.",
  Submit: "Submit",
  //Customer Orders file end
  //plates Content file start
  "Genie Tags": "Genie Tags",
  Code: "Code",
  "No Data Available": "No Data Available",
  //plates Content file start
  //Customer Plates  file start
  Actions: "Actions",
  "Add Review": "Add Review",
  "Add Review Count": "Add Review Count",
  "View Clicks": "View Clicks",
  "Add Menu": "Add Menu",
  Graphs: "Graphs",
  "Business Networks": "Business Networks",
  "Business Photos": "Business Photos",
  "Business Graphs": "Business Graphs",
  "Business Menu": "Business Menu",
  //Customer Plates  file end
  //Offers file start
  "Inactive Offers": "Inactive Offers",
  "Expired Offers": "Expired Offers",
  "Create New Offer": "Create New Offer",
  "Add Offer": "Add Offer",
  "Delete Offer": "Delete Offer",
  "Edit Offer": "Edit Offer",
  Update: "Update",
  "Expiration Date": "Expiration Date",
  "Coupon Code": "Coupon Code",
  Description: "Description",
  "Offer Title": "Offer Title",
  "Are you sure you want to delete this offer?":
    "Are you sure you want to delete this offer?",
  Save: "Save",
  "No Expired Offers Available": "No Expired Offers Available",
  "Code copied successfully!": "Code copied successfully!",
  "No Inactive Offers Available": "No Inactive Offers Available",
  "No Offers Available": "No Offers Available",
  //Offers files end
  //Gallery file start
  Photostitle: "Photos",
  "No Images Available":
    "There are no Images yet,Click 'Upload Images' and get started!",
  "Upload Image": "Upload Image",
  "Upload Images": "Upload Images",
  "Delete Image": "Delete Image",
  "Are you sure you want to delete this image?":
    "Are you sure you want to delete this image?",
  "Uploading...": "Uploading...",
  Upload: "Upload",
  //Gallery file end
  //Profile file  start
  "Update Profile": "Update Profile",
  "Change Password": "Change Password",
  "Update Password": "Update Password",
  //Profile file  end
  //userbusinessreports file  start
  "Created Date": "Created Date",
  Networks: "Networks",
  "Filter Reports by": "Filter Reports by",
  //userbusinessreports file  end
  //manualordercreation file  start
  "Shipping Cost": "Shipping Cost",
  "Product Price": "Product Price",
  "Order Details": "Order Details",
  "Creating Order...": "Creating Order...",
  "Use billing address as Shipping address":
    "Use billing address as Shipping address",
  "Payment Details": "Payment Details",
  "Delivery Address": "Delivery Address",
  Phone: "Phone",
  Email: "Email",
  "Select Products": "Select Products",
  "Business Information": "Business Information",
  "Can't find your business? No worries.Enter your business name,":
    "Can't find your business? No worries.Enter your business name,",
  "city and postal code.": "city and postal code.",
  "Search for your business to get set up":
    "Search for your business to get set up",
  "Manual Order Creation": "Manual Order Creation",
  "Billing Address": "Billing Address",
  //manualordercreation file  end
  //Reviewprovider file start
  "Explore Our Socials and Share Your Feedback! Your Opinions Matter to Us!":
    "Explore Our Socials and Share Your Feedback! Your Opinions Matter to Us!",
  "Add a description to your All-In-One Plate to provide more information about your business. This will be visible on your page.":
    "Add a description to your All-In-One Plate to provide more information about your business. This will be visible on your page.",
  "Provider Name": "Provider Name",
  "Provider URL": "Provider URL",
  "WhatsApp Number": "WhatsApp Number",
  //Reviewprovider file end

  //customer pages
  //landingpage file start
  Address: "Address",
  Closed: "Closed",
  Connect: "Connect",
  Details: "Details",
  PointGenie: "PointGenie",
  reviews: "reviews",
  User: "User",
  "Play venue video": "Play venue video",
  "Venue video": "Venue video",
  "Previous media": "Previous media",
  "Next media": "Next media",
  "Show media": "Show media",
  "Close video": "Close video",
  "See this place live in PointGenie": "See this place live in PointGenie",
  "Check the vibe, view live updates, discover nearby hotspots, and earn points when you check in.":
    "Check the vibe, view live updates, discover nearby hotspots, and earn points when you check in.",
  "Open this place in PointGenie": "Open this place in PointGenie",
  "iPhone & Android": "iPhone & Android",
  Website: "Website",
  "Check Menu": "Check Menu",
  "Leave us a Google Review": "Leave us a Google Review",
  "Connect With Us and Share Your Feedback Your Opinion Matter to Us!":
    "Connect With Us and Share Your Feedback Your Opinion Matter to Us!",
  "Show Less...": "Show Less...",
  "View More...": "View More...",
  "Connect With Us": "Connect With Us",
  Share: "Share",
  Expires: "Expires",
  "More details..": "More details..",
  //landingpage file end
  //menu page file start
  "Connect With Us Share Your Feedback. Your Opinion Matters to Us!":
    "Connect With Us Share Your Feedback. Your Opinion Matters to Us!",
  "No Items Available": "No Items Available",
  //menu page file end
  //socialmediareview file start
  "Drag and drop the icon to change the order of appearance on your All-In-One Page.":
    "Drag and drop the icon to change the order of appearance on your All-In-One Page.",
  Continue: "Continue",
  //socialmediareview file end
  //plates file start
  "Please help us validate your business below":
    "Please help us validate your business below",
  "Powered by": "Powered by",
  "Choose a category": "Choose a category",
  Bars: "Bars",
  Lounge: "Lounge",
  "Beauty salon's": "Beauty salon's",
  Barbershop: "Barbershop",
  Restaurant: "Restaurant",
  "Genie tag": "Genie tag",
  Validate: "Validate",
  //plates file end

  //signup file start
  "Sign Up": "Sign Up",
  "To start setting up your new plate": "To start setting up your new plate",
  "Already have an account?": "Already have an account?",
  "Sign In": "Sign In",
  //signup file end

  //Home pages start
  //layoutdesign file

  Features: "Features",
  "How to Setup": "How to Setup",
  "Our App": "Our App",
  "Seamless Check-Ins": "Seamless Check-Ins",
  "PointGenie makes customer reviews seamless with NFC technology. No apps, no hassle—just tap and leave a review in seconds. Increase your visibility on Google and gain customer trust effortlessly!":
    "PointGenie makes customer reviews seamless with NFC technology. No apps, no hassle—just tap and leave a review in seconds. Increase your visibility on Google and gain customer trust effortlessly!",
  "Get Started Now!": "Get Started Now!",
  "Your customers will leave you": "Your customers will leave you",
  "a Review in Only 3 Seconds!": "a Review in Only 3 Seconds!",
  "Instant Google Review Access": "Instant Google Review Access",
  "Boost Your Online Presence in Seconds with just a tap, customers are instantly directed to your Google review page — no hassle, no delays. Watch your ratings soar!":
    "Boost Your Online Presence in Seconds with just a tap, customers are instantly directed to your Google review page — no hassle, no delays. Watch your ratings soar!",
  "Seamless Social Media Integration": "Seamless Social Media Integration",
  "Turn Visitors into Followers Get more likes, shares, and loyal fans. Customers can follow your social media profiles instantly with a simple tap.":
    "Turn Visitors into Followers Get more likes, shares, and loyal fans. Customers can follow your social media profiles instantly with a simple tap.",
  "Get more likes, shares, and loyal fans. Customers can follow your social media profiles instantly with a simple tap.":
    "Get more likes, shares, and loyal fans. Customers can follow your social media profiles instantly with a simple tap.",
  "Touchless Digital Menu Access": "Touchless Digital Menu Access",
  "Your Menu, Instantly in Their Hands Forget printed menus — showcase your latest specials, offers, and updates digitally with a seamless NFC experience.":
    "Your Menu, Instantly in Their Hands Forget printed menus — showcase your latest specials, offers, and updates digitally with a seamless NFC experience.",
  "Door Traffic Analytics": "Door Traffic Analytics",
  "Understand Your Customer Flow Track foot traffic patterns in real-time. Gain insights into peak hours, customer behavior, and more to optimize staffing and operations.":
    "Understand Your Customer Flow Track foot traffic patterns in real-time. Gain insights into peak hours, customer behavior, and more to optimize staffing and operations.",
  "As seen on": "As seen on",
  "Find the Perfect Spot to Display Your Genie Tag!":
    "Find the Perfect Spot to Display Your Genie Tag!",
  //sectionhome file
  "How to Setup your Product": "How to Setup your Product",
  "Boost Your Google Reviews in Just 10 Seconds- Delight Your Customers Effortlessly!":
    "Boost Your Google Reviews in Just 10 Seconds- Delight Your Customers Effortlessly!",
  title: "How to Setup your Product",
  subtitle:
    "Boost Your Google Reviews in Just 10 Seconds - Delight Your Customers Effortlessly!",
  steps: [
    {
      step: "Step 1",
      title: "Scan the QR code",
      description: "When you receive your plate, Scan the QR code.",
    },
    {
      step: "Step 2",
      title: "Activate your card",
      description:
        "You will arrive on the PointGenie App: Enter the activation code on your plate and activate it.",
    },
    {
      step: "Step 3",
      title: "You're all set!",
      description:
        "And that's all there is to it! You're now ready to collect your first reviews!",
    },
  ],
  //sectionthree file
  "Turn Customers into Fans with Genie Tag":
    "Turn Customers into Fans with Genie Tag",
  "Get more Google reviews, boost engagement, and showcase your menu — all in seconds.":
    "Get more Google reviews, boost engagement, and showcase your menu — all in seconds.",
  "Instant Review Boost – Customers scan, tap, and leave a review in 3 seconds":
    "Instant Review Boost – Customers scan, tap, and leave a review in 3 seconds",
  "Highlight Your Best – Show off your menu, daily specials, and services":
    "Highlight Your Best – Show off your menu, daily specials, and services",
  "Plug-and-Play Setup – No app installs. Works right out of the box":
    "Plug-and-Play Setup – No app installs. Works right out of the box",
  "Increase Visibility – More reviews = higher ranking on Google":
    "Increase Visibility – More reviews = higher ranking on Google",
  "Can't find your business?No worries. Enter your business name,":
    "Can't find your business?No worries. Enter your business name,",
  "BUNDLE & Save": "BUNDLE & Save",
  "Buy Now": "Buy Now",
  "30-Day Risk-Free trial": "30-Day Risk-Free trial",
  "Free Shipping": "Free Shipping",
  "Easy & Free Return": "Easy & Free Return",
  //section five file
  "Frequently Asked Questions": "Frequently Asked Questions",
  "Do I need a Google My Business local listing?":
    "Do I need a Google My Business local listing?",
  "Yes, your business must have a Google My Business listing to receive Google reviews. If you don’t have one, our team can help you create it.":
    "Yes, your business must have a Google My Business listing to receive Google reviews. If you don’t have one, our team can help you create it.",
  "Do my customers need a Google account to write a review?":
    "Do my customers need a Google account to write a review?",
  "Yes, customers must have a Google account to leave a review. However, most smartphone users already have one through YouTube, Gmail, or Google Maps—93% of smartphone owners, in fact.":
    "Yes, customers must have a Google account to leave a review. However, most smartphone users already have one through YouTube, Gmail, or Google Maps—93% of smartphone owners, in fact.",
  "Are the NFC plates compatible with all smartphones?":
    "Are the NFC plates compatible with all smartphones?",
  "Yes! 90% of smartphones have built-in NFC technology, and 100% of smartphones can scan QR codes, making it easy for all customers to interact.":
    "Yes! 90% of smartphones have built-in NFC technology, and 100% of smartphones can scan QR codes, making it easy for all customers to interact.",
  "How does contactless technology work?":
    "How does contactless technology work?",
  "Our plates use NFC (Near Field Communication), the same technology that powers contactless payments. When customers tap or scan, a link to your business review page instantly opens—no app downloads needed. Our chip only transmits a link and does not collect any personal information.":
    "Our plates use NFC (Near Field Communication), the same technology that powers contactless payments. When customers tap or scan, a link to your business review page instantly opens—no app downloads needed. Our chip only transmits a link and does not collect any personal information.",
  "Where do you ship, and how long does delivery take?":
    "Where do you ship, and how long does delivery take?",
  "We currently only ship within the United States. Orders are processed within 1-2 business days, and delivery typically takes 4-7 business days.":
    "We currently only ship within the United States. Orders are processed within 1-2 business days, and delivery typically takes 4-7 business days.",
  "Do I need an app or subscription to use PointGenie NFC tags?":
    "Do I need an app or subscription to use PointGenie NFC tags?",
  "No app or subscription is required! Our NFC plates work instantly by directing customers to Our proprietary Landing page from where they go to your Google review page when they tap or scan the tag.":
    "No app or subscription is required! Our NFC plates work instantly by directing customers to Our proprietary Landing page from where they go to your Google review page when they tap or scan the tag.",
  "How do I install my NFC plate?": "How do I install my NFC plate?",
  "Our plates are designed for easy installation. Simply peel and stick to a flat, clean surface like your front desk, tables, or checkout counter. For best results, place them in high-visibility areas.":
    "Our plates are designed for easy installation. Simply peel and stick to a flat, clean surface like your front desk, tables, or checkout counter. For best results, place them in high-visibility areas.",
  "Can I customize the NFC plate with my logo or branding?":
    "Can I customize the NFC plate with my logo or branding?",
  "On Request! We offer custom branding options to match your business identity. Contact us for details on personalized designs At support@pointgenie.com.":
    "On Request! We offer custom branding options to match your business identity. Contact us for details on personalized designs At support@pointgenie.com.",
  "Can I update the link on my NFC plate?":
    "Can I update the link on my NFC plate?",
  "Our standard NFC plates are pre-programmed to link to your proprietary landing page from where they can go to google on one tap. However,With the purchase of your tag you get access to your business dashboard from where you can add more links and take advantage of other features like Digital Menus and Specials.":
    "Our standard NFC plates are pre-programmed to link to your proprietary landing page from where they can go to google on one tap. However,With the purchase of your tag you get access to your business dashboard from where you can add more links and take advantage of other features like Digital Menus and Specials.",
  "Do you offer bulk pricing for large orders?":
    "Do you offer bulk pricing for large orders?",
  "Yes! If you need multiple NFC plates, we offer discounted bulk pricing. Contact us for a custom quote based on your order size at Support@pointgenie.com.":
    "Yes! If you need multiple NFC plates, we offer discounted bulk pricing. Contact us for a custom quote based on your order size at Support@pointgenie.com.",
  "What is your return policy?": "What is your return policy?",
  "We stand by the quality of our NFC plates! If you receive a damaged or defective product, you can request a replacement or refund within 30 days of delivery. Simply contact our support team with your order details.":
    "We stand by the quality of our NFC plates! If you receive a damaged or defective product, you can request a replacement or refund within 30 days of delivery. Simply contact our support team with your order details.",
  "What if I have more questions or need support?":
    "What if I have more questions or need support?",
  "We’re happy to help! Contact our support team anytime, and we’ll assist you with any questions or concerns please reach out to our Whatsapp Number 305-497-5941 or write to support@pointgenie.com.":
    "We’re happy to help! Contact our support team anytime, and we’ll assist you with any questions or concerns please reach out to our Whatsapp Number 305-497-5941 or write to support@pointgenie.com.",
  //reviews file
  "Why More Business Owners are": "Why More Business Owners are",
  "Choosing us Every Day": "Choosing us Every Day",
  "David Diaz": "David Diaz",
  "CorpoBello Spa": "CorpoBello Spa",
  "Puerto Rico US": "Puerto Rico US",
  "PointGenie has been a game-changer for my spa. Customers love checking in and leaving reviews, and we’ve seen a noticeable increase in new clients thanks to the positive feedback. It’s easy to use, and I love how simple it is to manage everything from one place!":
    "PointGenie has been a game-changer for my spa. Customers love checking in and leaving reviews, and we’ve seen a noticeable increase in new clients thanks to the positive feedback. It’s easy to use, and I love how simple it is to manage everything from one place!",
  "Ariel Perez": "Ariel Perez",
  "MostWanted Cuts": "MostWanted Cuts",
  "Newark, NJ US": "Newark, NJ US",
  "Honestly, I wasn’t sure if PointGenie would make a big difference, but wow — it’s been amazing. Our clients check in, leave reviews, and even follow us on social media right from the tag. It’s helped us build a solid online presence without much extra effort.":
    "Honestly, I wasn’t sure if PointGenie would make a big difference, but wow — it’s been amazing. Our clients check in, leave reviews, and even follow us on social media right from the tag. It’s helped us build a solid online presence without much extra effort.",
  "Lucy Lopez": "Lucy Lopez",
  "GetBeautyPro Studio": "GetBeautyPro Studio",
  "PointGenie makes it so easy for my clients to leave reviews right after their appointment. Since adding the tag, my Google reviews have doubled, and new clients say they found me because of all the great feedback. It’s been a huge win for my business!":
    "PointGenie makes it so easy for my clients to leave reviews right after their appointment. Since adding the tag, my Google reviews have doubled, and new clients say they found me because of all the great feedback. It’s been a huge win for my business!",
  "24/7/365 Live Support": "24/7/365 Live Support",
  "100% Secure Payment": "100% Secure Payment",
  //home pages end
  //footer file start
  "Be part of our community": "Be part of our community",
  Company: "Company",
  Blog: "Blog",
  "About Us": "About Us",
  "Contact Us": "Contact Us",
  "Affilate With Us": "Affilate With Us",
  Legal: "Legal",
  "Press Release": "Press Release",
  "Terms and Condition": "Terms and Condition",
  "Privacy Policy": "Privacy Policy",
  "Quick Links": "Quick Links",
  Login: "Login",
  "Copyright© 2025 Pointgenie LLC. All rights reserved.":
    "Copyright© 2025 Pointgenie LLC. All rights reserved.",
  "Handcrafted in Florida, USA": "Handcrafted in Florida, USA",
  //footer file end
  //checkout file start
  "Express checkout": "Express checkout",
  "Email or Phone": "Email or Phone",
  "Secure Checkout": "Secure Checkout",
  "Credit Card": "Credit Card",
  "Your info will be saved to a shop account. By continuing, you agree to shop's":
    "Your info will be saved to a shop account. By continuing, you agree to shop's",
  "Terms of service": "Terms of service",
  "and acknowledge the": "and acknowledge the",
  PrivacyPolicy: "PrivacyPolicy",
  "Genie Plate": "Genie Plate",
  "Sub total": "Sub total",
  Shipping: "Shipping",
  Total: "Total",
  "Complete Purchase": "Complete Purchase",
  "processing...": "processing...",
  //checkout file end
  //Thankyou file start
  "Thank You for Your Purchase!": "Thank You for Your Purchase!",
  "Your order has been successfully placed. We appreciate your business!":
    "Your order has been successfully placed. We appreciate your business!",
  "Back to Home": "Back to Home",
  "Ooops, The page not found": "Ooops, The page not found",
  //Thankyou file end
  //profile page form labels 
  "Full Name":"Full Name",
  "Date of Birth":"Date of Birth",
  "Old Password":"Old Password",
  "New Password":"New Password",
  "Confirm New Password":"Confirm New Password",
  //manual order creation from labesl
  "searchAddress": "Search for an address",
  "firstName": "First Name",
  "lastName": "Last Name",
  "city": "City",
  "address": "Address",
  "zipCode": "Zip Code",
  "enterTransactionId": "Enter Transaction ID",
};

export default en;
